<div id="footer">
    <div>
        Copyright Global Rate Set System Limited 2010 - {{footerProperties.currentYear}}
    </div>
    <div [innerHTML]="footerProperties.contactDetails">
    </div>
    <div>
        {{footerProperties.productVersion}} ({{footerProperties.ipAddress}})
    </div>
</div>
